import styled from 'styled-components';

export const MessageContainer = styled.div`
  text-align: right;
  font-size: 12px;
  color: #999;
`;
